import { Button, Modal, Tooltip } from '@getro/rombo';
import React from 'react';
import { Box, Flex } from 'rebass/styled-components';
import PropTypes from 'prop-types';
import { Filters } from './filters';

export const FiltersModal = ({
  sharedList,
  filters,
  filterCount,
  setFilters,
  saveFilters,
  resetFilters,
  extendedMode,
  showListFilters,
  onClose,
  clearFundFilters,
  disableSaveFilters,
  isSavingFilters,
}) => (
  <Box display={['block', 'block', 'none']}>
    <Modal
      isOpen
      onCancel={onClose}
      title="Filter contacts"
      pauseFocusTrap
      actions={
        <Flex alignItems="center" sx={{ gap: '8px' }}>
          <Tooltip
            position="top-start"
            sx={{
              '.tooltip-arrow': {
                transform: 'translate(10px, 0px) !important',
              },
            }}
            content={
              <Box fontSize="14px" color="neutral.0">
                {disableSaveFilters
                  ? 'No changes to save'
                  : 'Save selected filters to keep them active, including for the shared view.'}
              </Box>
            }
            trigger={
              <Button
                sx={{ cursor: disableSaveFilters ? 'not-allowed' : 'pointer' }}
                disabled={disableSaveFilters}
                size="small"
                loading={isSavingFilters}
                onClick={() => saveFilters(filters).then(() => onClose())}
              >
                Save filters
              </Button>
            }
          />
          {filterCount > 0 && (
            <Button variant="tertiary" size="small" px="8px" onClick={resetFilters}>
              Clear all filters
            </Button>
          )}
        </Flex>
      }
    >
      <Box sx={{ position: 'relative' }}>
        <Filters
          sharedList={sharedList}
          filters={filters}
          setFilters={setFilters}
          extendedMode={extendedMode}
          showListFilters={showListFilters}
          clearFundFilters={clearFundFilters}
        />
      </Box>
    </Modal>
  </Box>
);

FiltersModal.propTypes = {
  sharedList: PropTypes.object,
  filters: PropTypes.object.isRequired,
  filterCount: PropTypes.number.isRequired,
  setFilters: PropTypes.func.isRequired,
  resetFilters: PropTypes.func.isRequired,
  extendedMode: PropTypes.bool,
  onClose: PropTypes.func.isRequired,
  showListFilters: PropTypes.bool.isRequired,
  clearFundFilters: PropTypes.func.isRequired,
  disableSaveFilters: PropTypes.bool,
  isSavingFilters: PropTypes.bool,
  saveFilters: PropTypes.func,
};

FiltersModal.defaultProps = {
  sharedList: null,
  extendedMode: false,
  disableSaveFilters: false,
  isSavingFilters: false,
  saveFilters: () => {},
};
